'use strict';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit, TemplateRef,
  ViewChild
} from '@angular/core';
import {CurationNodeSelectionSource, CurationSettings} from '../../curation-dashboard/curation-setting';
import {CurationActionCreatorService} from '../../../services/curation-action-creator.service';
import {CurationEditorAbstract} from '../curation-editor-abstract';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {
  WorkflowBarActionsCreatorService
} from '@ispm/shared/components/workflow-bar/services/workflow-bar-actions-creator.service';
import {CurationUtils} from '../../../utils/curation-utils';
import {get, has, isEmpty, set} from 'lodash';
import {PanelsService} from "@ispm/layout/services/panels.service";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {TranslateService} from "@ngx-translate/core";
import {CurationEditorHelper} from "../curation-editor-helper";
import {PathwaysAuthoringState} from "@ispm/shared/constants/pathways-authoring-state";
import {Store} from "@ngrx/store";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {NavigateToNodeWithData} from "@ispm-client/modules/bpmn-modeler/store/actions/node-navigator.action";
import {SetModelerContext} from "@ispm-client/modules/bpmn-modeler/store/actions/modeler-context.action";
import {ModelerPanelService} from "@ispm-client/modules/bpmn-modeler/service/modeler-panel.service";
import {ConfirmModalComponent} from "@ispm/layout/components/modals/confirm-modal/confirm-modal.component";
import {ModalTypes} from "@ispm/layout/components/modals/contants/modal-types.enum";
import {
  NodePanelConfigurationService
} from "@ispm-client/modules/bpmn-modeler/service/node-panel-configuration.service";
import {Observable} from "rxjs/Rx";
import {Actions} from "@ngrx/effects";
import {ClearUnsavedActions} from "@ispm-client/modules/bpmn-modeler/store/actions/user-initiated-actions.actions";
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {DiagnosticOrderService} from '@ispm/dashboard/test/services/diagnostic-order.service';
import {ActivityService} from '@ispm/user/services/activity.service';
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {NotesService} from '@ispm/user/services/notes.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {TreeViewPanelService} from '@ispm-client/modules/bpmn-modeler/service/tree-view-panel.service';
import {PanelPosition} from '@ispm/layout/components/panel/panel.component';
import {PathwayJsonTreeConverterService} from '../../../services/pathway-json-tree-converter.service';
import {ChangeSelectedNode} from '@ispm-client/modules/bpmn-modeler/store/actions/explorer-view.actions';
import {NodesPlaceViewCalculationsService} from "../../../services/nodes-place-view-calculations.service";
import { ActivatedRoute, Router } from "@angular/router";
import {NodeType} from "@ispm/shared/bpmn-io/node-type";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {PlacementData, PlacementNodeData} from "@ispm-client/modules/bpmn-modeler/models/placement.data";
import {Message, MessageService} from "@wuitk/angular/components/notification";
import {UpdateTreatmentNodesProperties} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {first} from "rxjs/operators";
import {ReplaySubject} from "rxjs";

@Component({
  selector: 'gen-curation-editor-placement',
  templateUrl: './curation-editor-placement.component.html',
  styleUrls: ['./curation-editor-placement.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationEditorPlacementComponent extends CurationEditorAbstract implements OnInit, OnDestroy {
  private DEFAULT_RIGHT_PANEL_WIDTH = 518;
  private DEFAULT_SHIFT_FROM_RIGHT_PANEL = 32;

  private readonly prefetchFormsForPlacement = ['PATHWAYBPMN-CLINICAL-TRIAL-NODES-SELECTION', 'PATHWAYBPMN-CLINICAL-TRIAL-NODE-CARD'];
  @ViewChild("messageTemplate") messageTemplate: TemplateRef<any>;
  public formName: string;
  public showBpmnModeler: boolean = false;
  public modelerVisible: boolean = true;
  public hideBpmnLogo: boolean = true;
  public discipline: string = '1';
  public isModelerReady: boolean = false;
  public pathwayBpmnCurationItem: any;
  public pathwayBpmnState = PathwaysAuthoringState.readonly;
  public pathwayBpmnModelerCfg: any;
  public pathwayPerformTreeRepair: string;
  public pathwayBpmnDiscipline: any;
  public pathwayBpmnCurationData: any;
  public revisiedEntitiesTableData: any;
  public isPathwayDataLoaded: boolean = false;
  private nodeId: string;
  private data: PlacementData;
  private placementStatus: string;
  private subscription;
  public showTreeViewContainer: boolean = false;
  public bpmnTreeViewPanel = TreeViewPanelService.BpmnTreeViewlPanelName;
  public bpmnTreeViewPanelPosition = PanelPosition.LEFT;
  public treeViewConfig: any;
  private latestSelectionSource: CurationNodeSelectionSource = CurationNodeSelectionSource.modelerView;
  public explorerViewIsVisible: boolean = false;
  private explorerViewIsInExpandedState: boolean = false;
  private selectedNodeId: any = undefined;
  private explorerViewNodeStateMap: Map<string, boolean> = new Map<string, boolean>();
  private rightSidebarOpen: boolean = true;
  private explorerViewOpen: boolean = false;
  private unsavedChanges: boolean = false;
  public globalNotificationClass: string = "global-notification-left-closed-right-open";

  constructor(authService: AuthenticationService,
              formHandler: FormHandlerService,
              public notificationMessageService: NotificationMessageService,
              workflowBarActionsCreatorService: WorkflowBarActionsCreatorService,
              modalLoader: DynamicModalLoaderService,
              activatedRoute: ActivatedRoute,
              panelService: PanelsService,
              curationActionCreatorService: CurationActionCreatorService,
              actions$: Actions,
              translateService: TranslateService,
              protected diagnosticOrderService: DiagnosticOrderService,
              notesService: NotesService,
              coreAC: CoreActionCreatorService,
              detector: ChangeDetectorRef,
              private store$: Store<State>,
              private modelerPanelService: ModelerPanelService,
              private nodePanelConfigurationService: NodePanelConfigurationService,
              public userActionCreatorService: UserActionCreatorService,
              public activityService: ActivityService,
              workflowConfigService: WorkflowConfigService,
              _http: HttpInterceptorService,
              router: Router,
              routerManagerService: RouterManagerService,
              public treeViewPanelService: TreeViewPanelService,
              private pathwayDataConverter: PathwayJsonTreeConverterService,
              private nodesPlaceViewCalculationsService: NodesPlaceViewCalculationsService,
              private messageService: MessageService) {
      super(authService, formHandler, notificationMessageService, workflowBarActionsCreatorService, modalLoader, activatedRoute,panelService, notesService, coreAC, curationActionCreatorService, translateService,
        diagnosticOrderService, userActionCreatorService, activityService, _http, router,undefined, detector, workflowConfigService, routerManagerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.preFetchForms(this.prefetchFormsForPlacement);
    this.selectedNodeId = undefined;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  public setInitParams() {
    this.showBpmnModeler = has(this.conf, 'ui.bpmnModeler');
    if (this.showBpmnModeler) {
      this.initBpmnModeler();
    }
    this.hideBpmnLogo = get(this.conf, 'ui.hideBpmnLogo', true);
    this.treeViewConfig = get(this.conf, 'ui.treeView', undefined);
    this.showTreeViewContainer = !!this.treeViewConfig && this.showBpmnModeler;

    this.formName = this.conf['ui']['forms']['editorForms']['details'].name;
    this.curationActionCreatorService.getState(['definitions'])
      .take(1)
      .subscribe(data => {
        this.confMap = Array.from(data.values()).filter(data => data['type'] === this.curationType || data['type'] === 'curationKB');
      });
  }

  public prepareDataToSave(status: string, prevStatus: string): Promise<boolean> {
    // check data consistency: nodeId should be defined
    // bypass data consistency check for archiving
    if (status === CurationSettings.CURATION_STATUS_WAITING_FOR_ARCHIVE || status === CurationSettings.CURATION_STATUS_ARCHIVED_SUBMITTED ||
      (status === CurationSettings.CURATION_STATUS_DRAFT && prevStatus === CurationSettings.CURATION_STATUS_WAITING_FOR_ARCHIVE) ||
      this.testDataConsistency(status)) {
      const confRoot = this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB)[0];
      CurationUtils.updateRelatedEntities(confRoot, this.curationItem.curationData);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }

  public getCurationKey(): string {
    return this.curationItem.curationData['content']['externalAutoGen'] + ' ' + this.curationItem.curationData['content']['placementName'];
  }

  public updateForm(form, updateFieldKeys: any) {
    if (form && updateFieldKeys) {
      for (const updatedField of updateFieldKeys) {
        set(this.curationItem.curationData['content'], updatedField, get(form, updatedField));
      }
      this.curationKey = this.getCurationKey();
    }

    // Handles GEN-41938: when pathway revision is changed, deploymentId data of the the updated pathway (new revision) is saved
    if (Array.isArray(updateFieldKeys) && updateFieldKeys.includes('pathway')) {
      if (form.pathway && form.pathway.code) {
        this.copyDataFromRelatedCurations(true, false, form['pathway']['code']).then((pathway) => {
          // Handle GEN-42231: clear node dropdown selected value in case pathway revision was changed and the new revision does not contain the previous revision selected node (node was deleted)
          if (pathway) {
            let nodeFound: boolean = false;
            const nodes = get(pathway.find(item => {
              return get(item, 'curationData.content.type') === 'pathwaybpmn';
            }), 'curationData.content.bpmn.nodes');
            if (nodes) {
              for (const nodeId of Object.keys(nodes)) {
                if (nodeId === form['node']['code']) {
                  nodeFound = true;
                  break;
                }
              }
            }
            if (!nodeFound) {
              this.formData['node'] = null;
              this.formData = Object.assign({}, this.formData); // Causing dynamic forms to repaint itself with the updated value (null node)
            }
          }
        }).catch((err) => {
          console.error(err);
        });
      }
    }
  }

  public validationEvent(valid) {
    this.isValid = valid;
  }

  public deleteItem($event) {
    // remove deleted element from validation
    this.validationFormsMap.delete($event.key);
    this.calculateValidationState();
  }

  public postGetCurationItem() {
    this.isDataLoaded = true;
  }

  public postUpdateCurationItem() {
    this.updateForm(this.curationItem.curationData['content'], null);
  }

  public override postReassignCurationItem() {
    this.openModelerPanel(false);
  }

  public override postArchiveRejectionCurationItem() {
    this.openModelerPanel(false);
  }

  public override postRejectionCurationItem() {
    this.openModelerPanel(false);
  }

  // Returns array with related entity (clinical trail and pathway bpmn) curationItemId's
  public getCurrentRelatedEntitiesIds(): Array<string> {
    const itemsArray = [];
    if (has(this.curationItem, 'curationData.content.clinicalTrial')) {
      itemsArray.push(get(this.curationItem, 'curationData.content.clinicalTrial.code'));
    }
    if (has(this.curationItem, 'curationData.content.pathway')) {
      itemsArray.push(get(this.curationItem, 'curationData.content.pathway.code'));
    }
    return itemsArray;
  }

  public async changeStatus(status: string, callback?: any) {
    if (this.showBpmnModeler) {
      if (!this.isStatusChangedFromReadToWrite(status)) {
        this.unsavedChanges = false;
        this.store$.dispatch(new ClearUnsavedActions());
      }
    }

    this.placementStatus = status;
    super.changeStatus(status, callback);
  }

  private isStatusChangedFromReadToWrite(status) {
    return (this.isPublishedStatus(this.curationStatus) && status === CurationSettings.CURATION_STATUS_DRAFT) ||
      (this.curationStatus === CurationSettings.CURATION_STATUS_REJECTED && status === CurationSettings.CURATION_STATUS_DRAFT);
  }

  //////////////////////////////////////////////
  // BPMN Modeler methods
  //////////////////////////////////////////////
  public onModelerRender(isModelerRendered) {
    if (isModelerRendered) {
      this.isModelerReady = true;
      this.openModelerPanel();
    }
  }

  private openModelerPanel(isSetFirstNodeAsSelected: boolean = true) {
    this.collectPlacementData().pipe(first())
      .subscribe((data: PlacementData) => {
        this.modelerPanelService.openNodeBuilderWithComponent('clinicalTrialSelector',
          this.pathwayBpmnModelerCfg.panel.componentToLoad, data,
          this.revisedEntitiesRevisionsData, this.isReadOnlyMode(), this.onPlacementUpdated.bind(this));

        if (isSetFirstNodeAsSelected) {
          let nodes: string[] = data.nodes.map((node: PlacementNodeData) => {
            return node.nodeId;
          });

          this.store$.dispatch(new UpdateTreatmentNodesProperties({nodes, data}));
          if (data.nodes && data.nodes.length > 0) {
            this.store$.dispatch(new NavigateToNodeWithData({
              nodeId: data.nodes[0].nodeId,
              openPanel: false,
              data: this.nodesPlaceViewCalculationsService.calculateShiftData()
            }));
          }
        }
      });
  }

  private convertNodeToViewModel(node: any): PlacementNodeData {
    const statusCode = get(node, 'status.code', 'Active');
    const availability: string = (statusCode === 'Active' || statusCode === null) ? 'true' : 'false';
    return {
      nodeId: node.node.code,
      availability,
      condition: node.condition,
      removed: false,
      selected: false
    }
  }

  private convertNodeFromViewModel(node: any) {
    const availability: string = (node.availability === 'true') ? 'Active' : 'Inactive';
    return {
      node: {
        code: node.nodeId,
        display: node.nodeId
      },
      status: {
        code: availability,
        display: availability
      },
      condition: node.condition
    }
  }

  public onPlacementUpdated($event: any) {
    if (!!$event) {
      const placementName = get($event, CurationSettings.NODE_UPDATE_FIELD_PLACEMENT_NAME, undefined);
      set(this.curationItem.curationData, CurationSettings.CONTENT_PLACEMENT_NAME, placementName);
      const clinicalTrial = get($event, CurationSettings.NODE_UPDATE_FIELD_CLINICAL_TRIAL, undefined);
      if (has(this.curationItem, 'curationData.content.clinicalTrial') && !!clinicalTrial) {
        Object.assign(this.curationItem.curationData['content']['clinicalTrial'], clinicalTrial);
        this.curationKey = this.getCurationKey();
      }
      const nodes = get($event, CurationSettings.NODE_UPDATE_FIELD_NODES, []);
      set(this.curationItem.curationData, 'content.nodes', nodes.map(node => this.convertNodeFromViewModel(node)));
      this.setModelerContext($event, true);
    } else {
      this.modelerPanelService.closePanel();
    }
  }

  private collectPlacementData(): Observable<PlacementData> {
    let clinicalTrialSubject: ReplaySubject<PlacementData> = new ReplaySubject(1);
    let clinicalTrial = get(this.curationData, 'content.clinicalTrial', {});
    if (clinicalTrial && clinicalTrial.display && !has(clinicalTrial, 'clinicalTrialId')) {
      this.curationActionCreatorService.getCurationItemV1(clinicalTrial.code, clinicalTrial.revisionId, CurationSettings.CURATION_CLINICAL_TRIAL, false)
        .pipe(first())
        .subscribe(res => {
          if (res && res.curationData) {
            clinicalTrial.clinicalTrialId = get(res, "curationData.content.nctId", undefined);
          }
          clinicalTrialSubject.next(this.setPlacementData(clinicalTrial));
          clinicalTrialSubject.complete();
        });
    } else {
      clinicalTrialSubject.next(this.setPlacementData(clinicalTrial));
      clinicalTrialSubject.complete();
    }

    return clinicalTrialSubject.asObservable();
  }

  private setPlacementData(clinicalTrial): PlacementData {
    let nodes = get(this.curationData, 'content.nodes', []);
    let data: PlacementData = {
      placementName: get(this.curationData, CurationSettings.CONTENT_PLACEMENT_NAME, undefined),
      clinicalTrial: clinicalTrial,
      clinicalTrialId: get(this.curationData, 'content.clinicalTrial.clinicalTrialId', undefined),
      nodes: nodes.map(node => this.convertNodeToViewModel(node))
    };
    this.markRemovedNodes(data.nodes);
    this.notifyRemovedNodes(data);
    return data;
  }

  private initBpmnModeler() {
    this.pathwayBpmnModelerCfg = get(this.conf, 'ui.bpmnModeler');
    this.revisiedEntitiesTableData.columns = get(this.pathwayBpmnModelerCfg, 'revisiedEntitiesTable.columns', undefined);
    this.revisiedEntitiesTableData.rowData = get(this.pathwayBpmnModelerCfg, 'revisiedEntitiesTable.rowData', undefined);
    this.nodesPlaceViewCalculationsService.defaultRightPanelWidth = get(this.treeViewConfig, 'defaultRightPanelWidth', this.DEFAULT_RIGHT_PANEL_WIDTH);
    this.nodesPlaceViewCalculationsService.shiftFromRightPanel = get(this.treeViewConfig, 'shiftFromRightPanelPix', this.DEFAULT_SHIFT_FROM_RIGHT_PANEL);

    let pathwayRevisionId, pathwayCurationId;

    // get suitable pathway bpmn data
    if (this.isPublishedStatus(this.curationStatus)) {
      const pathway = get(this.curationItem.curationData, 'content.pathway');
      if (!!pathway) {
        pathwayRevisionId = get(pathway, 'revisionId');
        pathwayCurationId = this.getPathwayCurationItemId();
      } else {
        this.notificationMessageService.error('Cannot find data for related pathwayBpmn');
      }
    } else {
      const pathwayRelatedEntity = this.getPathwayRelatedEntity();
      if (!!pathwayRelatedEntity) {
        pathwayRevisionId = this.getPathwayRevisionId(pathwayRelatedEntity);
        pathwayCurationId = pathwayRelatedEntity.identifiers.filter(item => item.system === 'curationItemId').map(item => item.value)[0];
        // update content.pathway descriptor in curationdata
        this.updateContentDataFromRelatedEntities();
      } else {
        this.notificationMessageService.error('Cannot find data for related pathwayBpmn');
      }
    }
    this.loadPathwayBpmn(pathwayCurationId, pathwayRevisionId);
  }

  private loadPathwayBpmn(pathwayCurationId, pathwayRevisionId) {
    this.curationActionCreatorService.getCurationItemV1(pathwayCurationId, pathwayRevisionId, CurationSettings.CURATION_PATHWAY_BPMN)
      .subscribe(res => {
        if (res.status === CurationEditorHelper.ERROR_ITEM_NOT_FOUND.toString()) {
          this.notificationMessageService.error('Cannot load pathwayBpmn curation item: ' + res['error'] + '. ' + res['details']);
        } else {
          this.pathwayBpmnCurationItem = res;
          this.pathwayBpmnCurationData = get(this.pathwayBpmnCurationItem, 'curationData', undefined);
          this.pathwayBpmnDiscipline = get(this.pathwayBpmnCurationData, 'content.discipline.code', undefined);

          // update clinicalTrial data in suitable node to be shown when modeler draws the tree
          if (!has(this.curationItem.curationData, 'content.discipline')) {
            set(this.curationItem.curationData, 'content.discipline', get(this.pathwayBpmnCurationData, 'content.discipline'));
            set(this.oldCurationItem.curationData, 'content.discipline', get(this.pathwayBpmnCurationData, 'content.discipline'));
          }
          if (!has(this.curationItem.curationData, 'content.disease')) {
            set(this.curationItem.curationData, 'content.disease', get(this.pathwayBpmnCurationData, 'content.disease'));
            set(this.oldCurationItem.curationData, 'content.disease', get(this.pathwayBpmnCurationData, 'content.disease'));
          }

          // GEN-206334
          let currValue = get(this.curationData, 'content.pathway.processId');
          set(this.curationData, 'content.pathway.processId', get(this.pathwayBpmnCurationData, 'content.bpmn.bpmnIdentifier.processId', currValue));
          currValue = get(this.curationData, 'content.pathway.deploymentId');
          set(this.curationData, 'content.pathway.deploymentId', get(this.pathwayBpmnCurationData, 'content.bpmn.bpmnIdentifier.deploymentId', currValue));

          this.collectPlacementData().pipe(first())
            .subscribe((data: PlacementData) => {
              this.setModelerContext(data);
              this.isPathwayDataLoaded = true;
          this.detector.detectChanges();
            });
        }
      });
  }

  private setModelerContext(modelerContext, unsavedChanges: boolean = false) {
    this.store$.dispatch(new SetModelerContext({modelerContext}));
    this.notifyRemovedNodes(modelerContext);
    this.unsavedChanges = unsavedChanges;
  }

  private calculateValidationState() {
    let valid: boolean = true;
    this.validationFormsMap.forEach((value: boolean, key: string) => {
      if (value === false) {
        valid = false;
      }
    });
    this.isValid = valid;
    this.calculateState();
  }

  private markRemovedNodes(nodes) {
    if (!isEmpty(nodes)) {
      nodes.forEach(node => {
        node.removed = !this.doesNodeExistInPathway(node.nodeId);
      });
    }
  }

  private doesNodeExistInPathway(nodeId: string) {
    return has(this.pathwayBpmnCurationData, 'content.bpmn.nodes.' + nodeId);
  }

  public dismissNotification() {
    this.messageService.clearAll();
  }

  public notifyRemovedNodes(modelerContext: object) {
    this.dismissNotification();
    const nodes = get(modelerContext, CurationSettings.NODE_UPDATE_FIELD_NODES, []);
    if (!isEmpty(nodes) && nodes.some(node => node.removed)) {
      let message: Message = {
        title: 'Required update',
        body: 'One or more nodes which contains placements were removed or changed',
        template: this.messageTemplate,
        key: 'single-line',
        icon: 'info',
        type: 'SINGLE_LINE',
        severity: 'info',
        sticky: true,
        closable: true,
        classNames: 'placement-global-notification',
        buttons: [{
          label: 'Close',
          action: () => this.messageService.clearMessage(message)
        }]
      }
      this.messageService.add(message);
    }
  }

  public isReadOnlyMode() {
    return this.readOnlyMode || !this.isCurationItemAssignedToCurrentUser;
  }

  private getPathwayRevisionId(pathwayRelatedEntity: any) {
    let revisionId = pathwayRelatedEntity.revisionId;

    if (has(pathwayRelatedEntity, 'upToDate') && !get(pathwayRelatedEntity, 'upToDate', false)
      || has(pathwayRelatedEntity, 'latestStatus')) {
      // pathwayBpmn is not latest, and placement is not in 'approved' or 'published' state
      if (!this.isPublishedStatus(this.curationData['status'])) {
        // we will load the latest version of pathwayBpmn
        revisionId = get(pathwayRelatedEntity, 'latestWorkflowRevisionId', revisionId);
      }
    }
    return revisionId;
  }

  submitCurationItemForReview() {
    if (this.testDataConsistency(CurationSettings.CURATION_STATUS_INREVIEW)) {
      super.submitCurationItemForReview();
    }
  }

  private actionNameByStatus(status: string): string {
    switch (status) {
      case CurationSettings.CURATION_STATUS_INREVIEW:
        return 'submitting for review';
      case CurationSettings.CURATION_STATUS_PUBLISHED_SUBMITTED:
        return 'publishing';
      default:
        return 'saving';
    }
  }

  private testDataConsistency(status: string) {
    // If the placement is candidate for publishing, check for completeness
    let hasBrokenNodes = false;
    let nodes = get(this.curationData, 'content.nodes', []);
    let forFinalVersion = this.isCandidateForPublishing(status);
    if (forFinalVersion) {
      hasBrokenNodes = nodes.some(node => !this.doesNodeExistInPathway(node.node.code));
    }
    let missingNodes = isEmpty(get(this.curationData, 'content.nodes', []));
    let missingTrial = !get(this.curationData, 'content.clinicalTrial.curationDataId');
    let missingName = !get(this.curationData, 'content.placementName');
    let errors: string[] = [];
    if (missingName) {
      errors.push('Placement name is missing');
    }
    if (missingTrial) {
      errors.push('No clinical trial is selected')
    }
    if (missingNodes) {
      errors.push('No nodes are selected');
    }
    if (hasBrokenNodes) {
      errors.push('Some of the selected nodes are no longer in the pathway')
    }
    let action = this.actionNameByStatus(status);
    if (!isEmpty(errors)) {
      const message =
        `Please fix the following before ${action}:\n- ` +
        errors.join('\n- ');
      this.modalLoader.popupModal(ConfirmModalComponent,
        {
          title: 'Error',
          content: message,
          approveBtn: 'Close',
          declineBtn: ''
        }, ModalTypes.ALERT).subscribe((response) => {
      });
      return false;
    }
    return true;
  }

  protected unsavedChangesExist(userAction: boolean = false): Observable<boolean> {
    if (this.showBpmnModeler) {
      return new Observable<boolean>((observer) => {
        observer.next(this.unsavedChanges);
        observer.complete();
      });
    } else {
      return super.unsavedChangesExist(userAction);
    }
  }

  private updateContentDataFromRelatedEntities() {
    const pathwayRelatedEntity = this.getPathwayRelatedEntity();
    // copy data from related entity to content
    const relatedEntityWorkflowRevisionName = has(pathwayRelatedEntity, 'latestWorkflowRevisionName') ?
      get(pathwayRelatedEntity, 'latestWorkflowRevisionName') : get(pathwayRelatedEntity, 'workflowRevisionName');

    const relatedEntityWorkflowRevisionId = has(pathwayRelatedEntity, 'latestWorkflowRevisionId') ?
      get(pathwayRelatedEntity, 'latestWorkflowRevisionId') : get(pathwayRelatedEntity, 'workflowRevisionId');

    if (get(this.curationData, 'content.pathway.revisionName') !== relatedEntityWorkflowRevisionName) {
      let currValue = get(this.curationData, 'content.pathway.curationDataId');
      set(this.curationData, 'content.pathway.curationDataId', get(pathwayRelatedEntity, 'latestCurationDataId', currValue));

      currValue = get(this.curationData, 'content.pathway.revisionId');
      set(this.curationData, 'content.pathway.revisionId', relatedEntityWorkflowRevisionId);

      currValue = get(this.curationData, 'content.pathway.revisionName');
      set(this.curationData, 'content.pathway.revisionName', relatedEntityWorkflowRevisionName);
    }
  }

  private getPathwayCurationItemId() {
    const pathway = get(this.curationItem.curationData, 'content.pathway');
    // for new version of placement created from pathwayBpmn editor
    if (!!pathway && has(pathway, 'curationItemId')) {
      return get(pathway, 'curationItemId');
    }
    // old version is created without pathwayBpmn and needed to be taken from related entities
    const pathwayRelatedEntity = this.getPathwayRelatedEntity();
    return !!pathwayRelatedEntity ? pathwayRelatedEntity.identifiers
      .filter(item => item.system === 'curationItemId').map(item => item.value)[0] : undefined;
  }

  private getPathwayRelatedEntity() {
    const relatedEntities = get(this.curationItem.curationData, 'relatedEntities');
    return !!relatedEntities ? relatedEntities.find(item => item.reviseItemType === 'pathway') : undefined;
  }

  toggleTreeViewerPanel() {
    if (this.explorerViewIsVisible) {
      this.treeViewPanelService.closePanel();
      this.explorerViewIsVisible = false;
    } else {
      const collapsedData = this.pathwayDataConverter.convertDataToTreeNodes(get(this.pathwayBpmnCurationData, 'content.bpmn'),
        get(this.pathwayBpmnCurationData, 'content.pathwayBpmnName'), false);
      const expandedData = this.pathwayDataConverter.convertDataToTreeNodes(get(this.pathwayBpmnCurationData, 'content.bpmn'),
        get(this.pathwayBpmnCurationData, 'content.pathwayBpmnName'), true);
      // TODO: create context menu items from configuration if there is
      // this.createTreeViewMenuItems(this.treeViewConfig);
      this.treeViewPanelService.openTreeViewPanel(this.treeViewConfig, {
        showExpanded: this.explorerViewIsInExpandedState,
        collapsedData: collapsedData,
        expandedData: expandedData,
        nodesStateMap: this.explorerViewNodeStateMap
      }, this.onTreeViewChanged.bind(this));
      this.explorerViewIsVisible = true;
      this.store$.dispatch(new ChangeSelectedNode({
        nodeId: this.selectedNodeId,
        type: NodeType.head,
        parent: undefined
      }));
    }
    this.setGlobalNotificationClass();
  }

  // this command is received from ExplorerView
  onTreeViewChanged(event) {
    switch (event.command) {
      case 'Close':
        this.treeViewPanelService.closePanel();
        break;
      case 'ChangeExpand':
        this.explorerViewIsInExpandedState = get(event, 'state', false);
        this.explorerViewNodeStateMap.clear();
        break;
      case 'NodeExpanded':
        this.setNodeState(event.nodeId, event.expanded);
        break;
      default:
        this.nodeSelectClicked(event);
        break;
    }
  }

  nodeSelectClicked(event: any) {
    if (event && event.selectedNode.data.id) {
      this.latestSelectionSource = CurationNodeSelectionSource.explorerView;
      this.selectedNodeId = event.selectedNode.data.id;
      const data = this.calculateShiftData(event);
      this.store$.dispatch(new NavigateToNodeWithData({
        nodeId: event.selectedNode.data.id,
        openPanel: false,
        data: data
      }));
    }
  }

  private calculateShiftData(event: any) {
    const data = event.selectedNode.leaf ? this.nodesPlaceViewCalculationsService.calculateShiftData()
      : (!event.selectedNode.parent ? {
        X: this.nodesPlaceViewCalculationsService.getXOffsetForHeadNode1(this.nodesPlaceViewCalculationsService.shiftFromRightPanel),
        Y: 0, shift: 'fromRightWithOffset'
      } : {X: 0, Y: 0, shift: undefined});
    return data;
  }

// node selected event can be received either from Explorer view or from modeler
  onNodeSelected($event) {
    this.selectedNodeId = get($event, 'newSelection[0].id', undefined);
    if (this.latestSelectionSource !== CurationNodeSelectionSource.explorerView) {
      const bpmnNodes = get(this.pathwayBpmnCurationData, 'content.bpmn.nodes', {});
      const foundNodeData = get(bpmnNodes, this.selectedNodeId);
      const payload = {
        nodeId: this.selectedNodeId,
        type: get(foundNodeData, 'type', 0),
        parent: get(foundNodeData, 'parentNodeIds', []).length > 0 ? get(foundNodeData, 'parentNodeIds', [])[0] : ''
      };

      this.store$.dispatch(new ChangeSelectedNode(payload));
    }
    this.latestSelectionSource = CurationNodeSelectionSource.modelerView;
  }

  explorerViewDisplayStatusChanged(display: boolean) {
    this.explorerViewIsVisible = display;
    this.nodesPlaceViewCalculationsService.updateRightPanelWidth();
    this.setGlobalNotificationClass();
  }

  private setGlobalNotificationClass() {
    if (this.rightSidebarOpen) {
      this.globalNotificationClass = this.explorerViewIsVisible
        ? "global-notification-left-open-right-open"
        : "global-notification-left-closed-right-open";
    } else {
      this.globalNotificationClass = this.explorerViewIsVisible
        ? "global-notification-left-open-right-closed"
        : "global-notification-left-closed-right-closed";
    }
  }

  onRightSidebarOpened(display: boolean) {
    this.rightSidebarOpen = display;
    this.setGlobalNotificationClass();
  }

  onRightPanelOpened(display: boolean) {
    if (display) {
      this.nodesPlaceViewCalculationsService.updateRightPanelWidth();
    }
    this.nodesPlaceViewCalculationsService.setRightPanelState(display);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.nodesPlaceViewCalculationsService.updateRightPanelWidth();
  }

  private setNodeState(nodeId: string, expanded: boolean) {
    this.explorerViewNodeStateMap.set(nodeId, expanded);
  }
}
